import { useMemo, useState } from "react";
import { HerdControlTabs } from "../utils/herdControl.utils";
import { useTranslations } from "adapters/i18n";

export function useHerdControlTabs() {
  const { t } = useTranslations();

  const [selectedTab, setSelectedTab] = useState<HerdControlTabs>(
    HerdControlTabs.ANIMAL_CATEGORY
  );

  const handleChangeTab = (target: HerdControlTabs) => {
    setSelectedTab(target);
  };

  const tabs = useMemo<{ id: HerdControlTabs; label: string }[]>(
    () => [
      {
        id: HerdControlTabs.ANIMAL_CATEGORY,
        label: t("animalCategory:animal-category"),
        show: true,
      },
      {
        id: HerdControlTabs.ENTRIES_AND_EXITS,
        label: t("movements:entries-and-exits"),
        show: true,
      },
      {
        id: HerdControlTabs.CONCILIATION,
        label: t("conciliation:conciliation"),
        show: true,
      },
      {
        id: HerdControlTabs.ARROBA_BALANCE,
        label: t("arrobaBalance:arroba-balance"),
        show: true,
      },
    ],
    [t]
  );

  return {
    handleChangeTab,
    selectedTab,
    tabs,
  };
}
